import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'clients',
    name: 'clients-list',
    redirect: { name: 'connection-view-clients', params: { id: 'all' } },
    meta: {
      permissions: [Permission.SuppliersClientsView],
    },
  },
  {
    path: 'clients/view/:id',
    name: 'connection-view-clients',
    component: () => import('./ConnectionViewClients.vue'),
    props: true,
    meta: {
      permissions: [Permission.SuppliersClientsView],
    },
  },
] satisfies RouteRecordRaw[];
